// Lightweight language controller for the Draffte Coach app.
// Mirrors the theme system (src/lib/theme.ts): a single localStorage key,
// a getter/setter, and an inline pre-paint script in the root layout that
// sets the <html lang> attribute before React hydrates. The actual React
// re-render on change is driven by the LangProvider (src/lib/i18n/LangProvider.tsx).
// Dependency-free — no next-intl / i18next.

export type Lang = "en" | "es";

const KEY = "draffte-lang";

export function getStoredLang(): Lang {
  if (typeof window === "undefined") return "en";
  try {
    const v = localStorage.getItem(KEY);
    return v === "es" ? "es" : "en";
  } catch {
    return "en";
  }
}

export function applyLang(l: Lang) {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("lang", l);
}

export function setStoredLang(l: Lang) {
  try {
    localStorage.setItem(KEY, l);
  } catch {
    /* private mode / storage blocked — still apply for the session */
  }
  applyLang(l);
}
